module.exports = __webpack_public_path__ + "img/is-safe-section-2.b0396830.png";